// extracted by mini-css-extract-plugin
export default {"scroll":"ContentWrapper_scroll__ElnuY","overlay":"ContentWrapper_overlay__M9kaF","wrapper":"ContentWrapper_wrapper__48R8u","fade":"ContentWrapper_fade__WXJow"};